import { RenderItemProps } from './types'
import { View, Text } from '@/components'
import { formatDateLocalized, variantProvider } from '@/app'
import { DebugItem } from './shared'
import { TagType } from '../atoms/TagType'
import { getDescriptionRandomColor, getDescriptionStyles, getTitleStyles } from '@/utils'

export const FeedText = (props: RenderItemProps) => {
  const { item } = props

  const creationDate = formatDateLocalized(new Date(item.created_datetime), 'learn.stories.date_format')
  const charDescriptionCount = item?.post?.description?.length || 0

  if (!item?.prompt && !item.post) return null

  return (
    <View style={styles.wrapper}>
      <DebugItem {...props} />

        <View variants={['row', 'fullWidth', 'justifySpaceBetween', 'alignCenter']}>
          <TagType icon={'text'} />
          <Text text={creationDate} variants={['p4', 'color:neutral6']} />
        </View>
        <View variants={['column', "gap:1"]} >
          <Text text={item.post?.title} style={getTitleStyles(charDescriptionCount)} />
          <Text text={item.post?.description} style={getDescriptionStyles(charDescriptionCount)} variants={getDescriptionRandomColor(Number(item?.id))} />
        </View>

        <View variants={['row', 'gap:0.5']}>
          <Text text={'Posted by'} variants={['p4', 'color:headlines']} />
          <Text text={` ${item?.profile?.display_name}`} variants={['p4', 'color:headlines', 'bold']} />
        </View>

    </View>
  )
}

const styles = variantProvider.createComponentStyle(theme => ({
  wrapper: {
    overflowY: 'auto',
    zIndex: 1,
    ...theme.spacing.paddingLeft(5),
    ...theme.spacing.paddingRight(3),
    ...theme.presets.column,
    ...theme.spacing.gap(1.5),
    ...theme.presets.fullWidth,
    [theme.media.down('small')]: {
      ...theme.spacing.paddingLeft(6),
      ...theme.spacing.paddingRight(4),
    }
  },
}), true)